import config from '@/config'

export const getTemplate = (userDetails, offerId, summary) => {
  let userString = 'Dear All, \r\n \r\n Please complete the approval / task according the below due date: \r\n \r\n'

  userDetails.forEach((userDetail) => {
    userString += `${userDetail.name}'s due date:  ${userDetail.dueDate}\r\n\r\n`
  })

  userString += `Executive Summary: \r\n ${summary}`
  return `${userString}
  
  You can view the offer in ${config.domain}/offers/${offerId}.
  ** Please note that only Siemens Employee can access this platform.
  `
}
